module.exports = __webpack_public_path__ + "img/virtual-reality.df3a341b.webp";